/**
 * i18n-Strings (deutsch).
 * Zentrale Quelle für alle UI-Texte.
 * Für späteren Sprach-Toggle (DE/EN): diese Datei als de.json ablegen,
 * en.json parallel, dann useTranslation()-Hook.
 */

export const t = {
  appName: "Akademie-Planer",
  appTagline: "Raum- und Seminarplanung",

  // Login
  login: {
    title: "Anmelden",
    subtitle: "Melde dich mit deinem Akademie-Konto an",
    email: "E-Mail",
    password: "Passwort",
    submit: "Anmelden",
    submitting: "Wird angemeldet…",
    errorInvalid: "E-Mail oder Passwort ist falsch",
    errorRateLimit:
      "Zu viele Anmeldeversuche. Bitte eine Minute warten.",
    errorGeneric: "Anmeldung fehlgeschlagen. Bitte erneut versuchen.",
  },

  // Navigation
  nav: {
    dashboard: "Dashboard",
    calendar: "Kalender",
    sessions: "Sessions",
    locations: "Standorte",
    rooms: "Räume",
    resources: "Ressourcen",
    trainers: "Trainer",
    users: "Benutzer",
    import: "Import",
    reports: "Auswertungen",
    settings: "Einstellungen",
    logout: "Abmelden",
  },

  // Dashboard (Placeholder)
  dashboard: {
    title: "Dashboard",
    upcoming: "Anstehende Sessions",
    empty: "Keine anstehenden Sessions",
  },

  // Common
  common: {
    save: "Speichern",
    cancel: "Abbrechen",
    delete: "Löschen",
    edit: "Bearbeiten",
    create: "Anlegen",
    back: "Zurück",
    loading: "Wird geladen…",
    error: "Fehler",
  },

  // Roles
  role: {
    admin: "Administrator",
    planer: "Planer",
    betrachter: "Betrachter",
  },
};
